import { faSquare } from '@fortawesome/pro-solid-svg-icons';

const LEGEND_ITEMS = [
  { key: 0, content: 'Low', iconProps: { icon: faSquare, size: '20px', color: '#ffd700' } },
  { key: 1, content: 'Middle', iconProps: { icon: faSquare, size: '20px', color: '#E5A300' } },
  { key: 2, content: 'High', iconProps: { icon: faSquare, size: '20px', color: '#E86A0A' } },
  { key: 3, content: 'Very high', iconProps: { icon: faSquare, size: '20px', color: '#cf0d14' } },
];

const FLASH_FLOOD_LEGEND_ITEMS = [
  { key: 0, content: 'Excellent', iconProps: { icon: faSquare, size: '20px', color: '#2b3990' } },
  { key: 1, content: 'Good', iconProps: { icon: faSquare, size: '20px', color: '#93268f' } },
  { key: 2, content: 'Sufficient', iconProps: { icon: faSquare, size: '20px', color: '#c41d69' } },
  { key: 3, content: 'Problematic', iconProps: { icon: faSquare, size: '20px', color: '#ed1c24' } },
];

export {
  LEGEND_ITEMS,
  FLASH_FLOOD_LEGEND_ITEMS,
}